import * as React from "react";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {UpdatingConfigurationTable} from "../../widgets/UpdatingConfigurationTable";
import {UpdatingConfigurationProgressBar} from "../../widgets/UpdatingConfigurationProgressBar";
import {useCurrentSettingsUpdateResult, useUpdatingProgressInfo} from "../../data/hooks/ReadAndWriteControllerHooks";
import {errorCountString} from "./utils";
import {getEditingSettings, getFormattedDate} from "../../ReadAndWrite/utils";
import "./styles.scss"
import {SWRResponse} from "swr";
import {DeviceSlaveCurrentSettings} from "../../data/models/DeviceSlaveSetting";
import {UpdatingSettings} from "../../data/models/UpdatingSetting";
import {delay} from "@vebox/etui-core";
import {PAGES} from "../MainContentPage";

const pollingTime = 10 * 1000; //seconds

interface UpdatingConfigurationPageProps {
}

export const UpdatingConfigurationPage: React.FC<UpdatingConfigurationPageProps> = () => {
    const {deviceSlaveSettings, deviceGuid, availableRegisters, changePage} = React.useContext(
        ReadAndWriteContext);
    const currentSettingsUpdateResult = useCurrentSettingsUpdateResult(deviceGuid);
    const updatingProgressInfo = useUpdatingProgressInfo(deviceGuid);

    const [updatingInfo, setLastUpdatingInfo] = React.useState<UpdatingSettings>(undefined);

    const deviceSlaveAvailableRegisters = availableRegisters?.data ?? [];
    const deviceSettings = deviceSlaveSettings?.data?.settings?.settings ?? [];
    const settings = getEditingSettings(deviceSettings, deviceSlaveAvailableRegisters) ?? [];


    const getSettingsToUpdate = (): UpdatingSettings => {
        return updatingInfo ?? updatingProgressInfo.data;
    }

    const askForUpdate = async (updatingProgressInfo: SWRResponse<UpdatingSettings, Error, any>,
                                deviceSlaveSettings: SWRResponse<DeviceSlaveCurrentSettings, Error, any>) => {
        const result = await updatingProgressInfo.mutate();
        if (result?.valuesUpdated === result?.updatingSettings?.length || result?.updatingSettings?.length === 0 || updatingProgressInfo.error) {
            setLastUpdatingInfo(updatingProgressInfo.data);
            await delay(2000);
            const deviceConf = await deviceSlaveSettings.mutate();
            if (deviceConf.updating || deviceConf.validating) {
                askForUpdate(updatingProgressInfo, deviceSlaveSettings);
            } else {
                changePage(PAGES.SETTINGS, true);
            }
        } else {
            await delay(pollingTime);
            askForUpdate(updatingProgressInfo, deviceSlaveSettings);
        }
    };


    React.useEffect(() => {
        askForUpdate(updatingProgressInfo, deviceSlaveSettings)
        setLastUpdatingInfo(undefined)
    }, [])

    return (
        <div className={"settings-main-container-updating"}>
            <UpdatingConfigurationProgressBar
                updatingFrom={getFormattedDate({dateToFormat: currentSettingsUpdateResult?.data?.startedAt})}
                total={getSettingsToUpdate()?.updatingSettings.length}
                count={getSettingsToUpdate()?.valuesUpdated}
                user={currentSettingsUpdateResult?.data?.user}
                errorsLabel={errorCountString(getSettingsToUpdate()?.updatingSettings ?? [])}
            />
            <UpdatingConfigurationTable
                settings={settings}
                updatingSettings={getSettingsToUpdate()}
                isValidating={getSettingsToUpdate()?.validating}
            />
        </div>
    );
};
